import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Urbanisation is a dynamic and irreversible process involving
              changes in land use land cover [LULC] leading to the conversion of
              rural area into urban area. Burgeoning population with impetus to
              the industrialization, political, cultural and other
              socio-economic factors act as catalysts of urbanisation. Unplanned
              urbanisation leads to the rapid landscape changes and urban sprawl
              with the increasing social, economic and environmental problems
              (Ramachandra et al., 2012; Yang et al. 2017). Landscape changes
              involving large scale land cover changes would have devastating
              effect on the vegetation, quality and quantity of surface and
              sub-surface water resources (Vinay et al. 2013), air quality and
              climatic factors (Grimm et al. 2008, 2015).
            </p>
            <p>
              The Government of India under the flagship Make-in-India programme
              has planned five industrial corridor projects spread across India,
              with strategic focus on inclusive development to provide an
              impetus to industrialization and planned urbanization. In each of
              these corridors, manufacturing is a key economic driver with a
              goal to increase the manufacturing sector contributions 15% to 25%
              by 2025 in the nation&rsquo;s Gross Domestic Product (GDP). Also,
              smart industrial cities are proposed along these corridors to
              integrate mobility with land uses (Department of Industrial Policy
              and Promotion and Government of India 2007). These industrial
              corridors connect major cities with the coastal cities for
              accessibility of locally available resources and mobility of
              global resources. The industries are strategically located along
              these corridors with the improved infrastructure, would increase
              job opportunities at local level, while improving the travel and
              transport efficiency, and reduction in transit time (DIPP, 2007;
              GOI, 2014). The industrial corridor initiative is expected to
              attract the regional and international investors with PPP (public
              private partnership), and create competitiveness among industries
              across and between regions/nations. This would also reduce cargo
              freight time, removing the barriers of employment, encouraging
              trade, tourism, economy and cooperation and at the same time
              cutting down cost of GHG (greenhouse gas) footprint.
              &nbsp;Globally, industrial Corridors have been established with
              the strategy of connecting major cities and industries (De and
              Iyengar 2014).
            </p>
            <p>
              Globally there are numerous examples of
              industrial/economic/infrastructure/trade corridors connecting
              CBD&rsquo;s to improve the socio-economic level of the local,
              regional or national such as Trans-European Transport Networks
              (TEN-T) (Trans-European Transport Network 2018;); Rhine-Alpine
              Corridor (Blue Banana) (European Commission);
              U.S.-Canadian-Mexican trade corridor; Trans-Kalahari Corridor
              connecting Walvis Bay (east coast) to and Maputo (west coast);
              SIJORI Growth Triangle (Milne 1993; Smith 1997) connecting
              Singapore, Indonesia and Malaysia. Eastern Economic Corridor
              Thailand (Georg et al. 2016) <em>etc. </em>The policy decisions
              that are likely to alter land cover in the region include
              industrial Corridors (Department of Industrial Policy and
              Promotion and Government of India 2007) and Bharatmala-Pariyojana
              (Government of India 2018), an umbrella program under the Ministry
              of Roads, Transport and Highway (Ministry of Road Tranport &amp;
              Highways and Government of India 2017). These programs focuses on
              increasing efficiency of movement of cargo, passengers bridging
              critical infrastructure gaps through effective interventions such
              as economic corridor, infrastructure corridor, industrial
              corridor, up-gradation of highways, increase in boarder and
              international connectivity, coastal and port connectivity,
              <em> etc.</em> &nbsp;These developments of connecting cities will
              have negative impacts such as urban sprawl while planned
              interventions would support the region&rsquo;s smart growth with
              the scope for sustainable development. The transportation network
              would induce the proportional social, economic and environmental
              impacts such as loss of open spaces, forests, water bodies{" "}
              <em>etc.</em> with increasing paved surfaces (McGrane 2016; Miller
              and Hutchins 2017; Ramachandra et al. 2014), fluctuating housing
              costs and expenditures over time (Ewing and Hamidi 2013). The
              corridors and its implications across time and space are less
              studied, as compared to studies made at city levels, despite being
              prime mover of the nation&rsquo;s development. &nbsp;
            </p>
            <p>&nbsp;</p>
            <p>
              The conventional approach to understand the landscape dynamics
              across industrial corridors is time consuming. However the
              availability of multi-resolution (spatial, spectral and temporal)
              remote sensing data with advances in &nbsp;GIS (Geographic
              Information System) technologies has proved reliable and
              economical for understanding landscape dynamics ( Ji et al. 2001;
              Ramachandra et al., 2012; Ramachandra and Bharath 2012). Different
              modeling techniques using rule based, agent based models such as
              CA, CA-Markov, Geomod, Land Change Modeler, SLEUTH, SLUCE,
              Dynamica, Dyna-CLUES, ANN, Multi Regression, AHP, CAPRI-Spat{" "}
              <em>etc.</em> have been widely used for geo-visualisation of
              landscape dynamics (Bharath et al. 2013, 2015, 2016; Brown et al.
              2008;&nbsp; Guan et al. 2005; Jain et al. 2017; Jokar Arsanjani et
              al. 2012; Macal and North 2008; Mena et al. 2011;&nbsp; Mohammady
              et al. 2014;&nbsp; Siddayao et al. 2014; Taubenb&ouml;ck et al.
              2009, 2012; Wassenaar et al. 2007).
            </p>
            <p>&nbsp;</p>
            <p>
              Urbanisation is very dynamic and complex process involving
              multiple agents with diverse behaviors under changing spatial and
              temporal scales (Cheng, 2003). Cellular Automata Markov Chain
              integrated model, a rule based model where in multiple rules are
              used in order to simulate the future scenario though historical
              data sets is proved to be one of the best modelling technique for
              urban growth simulation. Cellular Automata is used to predict the
              state of the cell based on the previous state of the cells within
              a neighborhood, using a set of transition rules. Markov is used to
              provide probabilistic transition events. Although CA-Markov gives
              promising results, it fails to achieve accurate results due to
              non-accounting of agents - urban driving forces (He et al. 2013).
              Agents based modelling (ABM) uses causal factors or agents that
              influence a particular process through interaction of the driving
              forces in the region of influences and defines the growth through
              neighborhood interaction of the drivers and the base modelling
              criteria. This communication is based on the ABM technique that
              generates the drivers of urban growth interaction through using
              fuzziness in the data sets and using Analytical Hierarchical
              Process (AHP) to account of its weight based interactions through
              CA-Markov process (Bharath et al. 2013). ABM method is effective
              in simulating the real change based on agents. ABM&rsquo;s
              weigh/rank the growth factors and constraints as reflected by the
              real world scenarios to develop site suitability maps in order to
              model the land use. The site suitability maps provide the
              transitional areas describing where the particular land use has
              the probability to change or retain its state. The site
              suitability maps are combined with the CA-Markov in order to
              simulate and predict the land use dynamics. The modelling based on
              ABM has emerged as a promising approach for understanding the
              complex urban processes. Integration of fuzzy rules and Analytical
              Hierarchal process (AHP) with ABM aid in defining the influence of
              the agents in urban simulation.
            </p>
            <p>
              The agent gradually transfers from a non-member to a member. This
              gradual transfer happens through a function called as membership
              function that is used to characterize various sets of agents that
              interact with a particular urban land use. These agent&rsquo;s
              interaction is treated as a fuzzy rule to define somewhat
              influential to least influential and a precise numerical. This
              involved building a fuzzy network to extract fuzzy rules through
              an expert system. The fuzzy sets of inputs through fuzzy rules are
              combined to represent the agent&rsquo;s strength, which is then
              combined with AHP to define the site suitability with interaction
              of the current land use to weigh characteristics of diverse
              opinions in a complex environment. This is a two-step process
              involving the assessment of effectiveness and alternatives. AHP
              has been a commonly used MCE technique for suitability of
              landscape through pair wise analysis (Chang et al., 2008, Chen et
              al., 2010, Thapa &amp; Murayama, 2008). Integration of artificial
              intelligence with MCD technique improves efficiency of modelling
              real world situation and for understanding spatial patterns of
              urbanization. This output is then used in CA-MARKOV for modelling
              as discussed earlier.
            </p>
            <p>
              Objective of this study is to assess landscape dynamics in Mumbai
              Pune expressway industrial corridor connecting Mumbai and Pune
              Cities and understand the spatial contextual improvisation of
              modelling techniques using agent based models.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
